<!--<p class="viewTitle">ClientApp\src\app\common\components\detail-container\detail-container.component.html</p>-->
<div class="container-fluid eca-outline-border detail-container" [ngClass]="containerClass">
<p-panel [toggleable]="true" toggler="icon" class="dashboard-card" (onBeforeToggle)="panelToggle()"
         collapseIcon="pi pi-fw pi-chevron-up" expandIcon="pi pi-fw pi-chevron-down"
         [(collapsed)]="isCollapsed" [transitionOptions]="'200ms'" [styleClass]="'p-panel-plain'" [iconPos]="'end'">
  <ng-template pTemplate="header">
    <ng-template *ngIf="isCollapsed" [ngTemplateOutlet]="collapsedContainerHeader"></ng-template>
    <ng-template *ngIf="!isCollapsed" [ngTemplateOutlet]="containerHeader"></ng-template>

    <div class="col-md col-sm-12 d-flex justify-content-end" style="padding: 5px; width:100% !important;">
      <ng-container [ngTemplateOutlet]="containerHeaderAction"></ng-container>
    </div>

  </ng-template>
  <ng-template pTemplate="content" class="dashboard-card-body">
    <ng-content></ng-content>
  </ng-template>
</p-panel>
</div>
